import { useTranslation } from 'react-i18next';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { isAssistantNotFound, useAssistantStatus } from 'api/assistant';

/** Mount private chat/knowledge pages only after affirmative discovery. */
export default function AssistantAccess() {
  const { t: translate } = useTranslation();
  const status = useAssistantStatus();
  if (status.isPending) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress size={24} aria-label={translate('assistant.assistantAccessLoadingPage')} /></Box>;
  }
  if (status.isError && !isAssistantNotFound(status.error)) {
    return (
      <Alert severity="error" action={<Button color="inherit" size="small" onClick={() => status.refetch()}>{translate('assistant.answerWidgetRetry')}</Button>}>{translate('assistant.assistantAccessCouldNotLoadTheAssistant')}</Alert>
    );
  }
  if (!status.isSuccess || status.data?.enabled !== true) {
    return <Typography color="text.secondary" sx={{ py: 8, textAlign: 'center' }}>{translate('assistant.assistantAccessPageNotFound')}</Typography>;
  }
  return <Outlet />;
}
